var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2363 0H1.23994C0.555349 0 0 0.555349 0 1.23994V21.2363C0 21.9218 0.555349 22.4762 1.23994 22.4762H12.0042V13.7723H9.07383V10.3812H12.0042V7.87603C12.0042 4.97379 13.7779 3.39484 16.3673 3.39484C17.6082 3.39484 18.6749 3.48568 18.9858 3.52689V6.56117H17.1868C15.782 6.56117 15.5086 7.2364 15.5086 8.21973V10.384H18.865L18.4295 13.7835H15.5086V22.4762H21.2353C21.9218 22.4762 22.4762 21.9218 22.4762 21.2363V1.23994C22.4762 0.555349 21.9218 0 21.2363 0Z",
    fill: "#0174EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.ca10ca011044af201193382a66861ea5.svg";
export { ForwardRef as ReactComponent };